import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {PowerSelect} from 'react-power-select';

const CustomOptionComponent = ({ option }) => (
<div className={option.account_holiday_status == 'on_holiday' ? 'bg-warning' : ''}>
<strong className='pl-2'>{option.company.short_name}</strong>&nbsp;
  <img
    src={"/user-images/"+option.id}
    className="drivers-powerselect-driver-image"
  />
  <span>{option.first_name} {option.last_name}</span>
  {option.account_holiday_status == 'on_holiday' && <strong className='float-right pt-3 pr-2'> on Holiday </strong>}
</div>
);

export default class DriversPowerSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      drivers: props.driversAll || [],
      defaultValue: props.defaultValue || '',
      job: props.job || '',
      selectedOption: '',
      isZonePage:props.isZonePage || false
    };
    Echo.
      channel('group-planning-zonetable-update').
      listen('GroupPlanningZoneTableUpdate', (e) => {
        if(this.state.job.id == e.jobId && this.state.isZonePage){
          let that = this;
          $.ajax({
            url: "/api/v1/portal/drivers/default/for-dropdown-menu/"+e.jobId,
            data: {api_token: window.api_token},
            cache: false
          })
          .done(function(defaultDriverJson) {
            that.setState({selectedOption: defaultDriverJson},()=>{
              console.log('done...........');
            });
          });
        }
    });
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.getDefaultDriver();
    this.getDrivers();
  }

  getDefaultDriver() {
    let that = this;
    if(that.state.job){
      $.ajax({
        url: "/api/v1/portal/drivers/default/for-dropdown-menu/"+that.state.job.id,
        data: {api_token: window.api_token},
        cache: false
      })
      .done(function(defaultDriverJson) {
        that.setState({
          selectedOption: defaultDriverJson
        });
      });
    }
  }

  getDrivers() {
    let that = this;
    $.ajax({
      url: "/api/v1/portal/drivers/all/for-dropdown-menu",
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(driversJson) {
      that.setState({ drivers: driversJson}, () => {
        if (that.state.defaultValue) {
          that.setState({
            selectedOption: driversJson.find(driver => driver.driver_id === that.state.defaultValue)
          });
        }
      });
    });
  }

  handleChange( { option })  {
    this.setState({
      selectedOption: option,
    })
    this.props.handleDriverSelection(option);
  }

  render() {
    return (
      <PowerSelect
        options={this.state.drivers}
        optionLabelPath="full_name"
        selected={this.state.selectedOption}
        onChange={this.handleChange}
        placeholder="-- select a Driver -- "
        optionComponent={<CustomOptionComponent />}
        required
        />
    )
  }
}
